import { DragEvent } from "react";
import { ChannelType, channelTypeInfo, areChannelTypesCompatible } from "../../models/ChannelType";
import Button from "../../models/Button";
import ButtonChannel from "../../models/ButtonChannel";
import { setChannelType, toggleButtonChannelSplit } from "../../models/buttonChannelActions";
import { useOnChangeWatcher } from "../../models/useOnChangeWatcher";
import EditableText from "../EditableText";
import { showToast } from "../Toasts";
import Connection from "../../models/Connection";
import Device from "../../models/Device";

import Logger from "../../Logger";
import Page from "../../models/Page";
import ConnectableObject from "../../models/ConnectableObject";
import AllowedConections from "../../models/AllowedConnections";
import Room from "../../models/Room";
import { DragMode } from "../../models/TreeviewModel";
import { itx, noItx } from "../../translationItx/itx";

import { isUiModeDeveloper, isUiModeProductAdmin } from "../../uiMode";
import Channel, { ButtonSide } from "../../models/Channel";
import { VariantType } from "react-tooltip";
import Scene from "../../models/Scene";
import { RockerConfig } from "../../models/KnxRules";
import Select from "react-select";
import ObjectReference from "../ObjectReference";
import { TAG_TX } from "../../models/Constants";

const logger = new Logger();

let dragChannel: Channel | undefined;

function ConnectionGroupElement(props: { channel: Channel; device: Device }) {
  const { channel, device } = props;
  useOnChangeWatcher(channel);
  useOnChangeWatcher(device);

  function handleOnDragStart(ev: DragEvent<HTMLDivElement>) {
    dragChannel = channel;
    ev.dataTransfer.setData("text", channel.id);
  }

  const connectionElements: any = [];
  function ConnectionGroupElement(props: { connection: Connection; first: boolean }) {
    const { connection, first } = props;
    const partner = connection.getPartner(channel);

    return (
      <div
        style={{
          position: "relative",
          display: "flex",
          justifyContent: "space-between",
          // borderTop: first ? "transparent" : "solid 1px grey", // no itx
          borderRadius: "2px",
          // height: "25px",
          backgroundColor: connection.forbidden ? "var(--backgroundColorError)" : "transparent",
        }}
        onClick={(ev) => {
          state.selectionManager.selectedObject = partner;
          ev.stopPropagation();
        }}
      >
        {connection.forbidden && (
          <img
            src={"images/alert.png"}
            style={{
              width: "25px",
              height: "25px",
              marginLeft: "10px",
              position: "relative",
            }}
            data-tooltip-id="tv-tooltip"
            data-tooltip-content={state.translate("oneButton.connectionNotAllowed", "connection Not Allowed")}
            data-tooltip-place="bottom"
          />
        )}

        <ObjectReference obj={partner} relative={device} useAllwaysMaxSpace={true} />

        <button
          className="button circle"
          style={{
            fontSize: "10px",
            height: "16px",
            width: "16px",
            float: "right",
          }}
          onClick={(ev) => {
            connection.delete();
          }}
          data-tooltip-id="tv-tooltip"
          data-tooltip-content={state.translate("oneButton.deleteConnection", "Verbindung löschen")}
          data-tooltip-place="top" // no itx
        >
          <i className="las la-unlink" />
        </button>
      </div>
    );
  }

  ///////////////////////////////////////////////////
  /////////////// connectionGroupElement
  ///////////////////////////////////////////////////

  let show = channelTypeInfo(channel.channelType).canBeConnectedWithButtonChannel;
  if (device.isPanel) {
    show ||= [
      ChannelType.StatusDisplaySwitch,
      ChannelType.StatusDisplayDimValue,
      ChannelType.StatusDisplayTemperature,
    ].includes(channel.channelType);
  }

  if (channel.channelType == ChannelType.TemperatureSetpoint || channel.isActorChannel || channel.isStatusChannel) {
    show = true;
  }

  if (show) {
    let first = true;
    channel.connections.forEach((connection) => {
      connectionElements.push(<ConnectionGroupElement connection={connection} first={first} />);
      first = false;
    });
    let isDragable = false;
    if (channel.connections.size > 0) {
      isDragable = true;
    }
    return (
      <div
        draggable={isDragable}
        onDragStart={(ev) => {
          handleOnDragStart(ev);
        }}
        onDragEnter={(ev: DragEvent<HTMLDivElement>) => {
          logger.log(`onDragEnter:${dragChannel?.name}`);
        }}
        onDragLeave={(ev: DragEvent<HTMLDivElement>) => {
          logger.log(`onDragLeave:${dragChannel?.name}`);
        }}
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          cursor: isDragable ? "ns-resize" : "default", // no itx

          minHeight: "100%",
          minWidth: "100%",
          alignItems: "center",
        }}
      >
        <i
          className="las la-bars"
          style={{
            backgroundColor: "##var(--lightLightGrey)",
            border: "1px solid var(--borderColorDarkGrey)",
            borderRadius: "10px 0px 0px 10px ",
            height: "20px",
            width: "25px",
            padding: "2px",
            paddingLeft: "5px",
            color: isDragable ? "var(--defaultActiveColor)" : "var(--defaultNotActiveColor)", // no itx
          }}
          data-tooltip-id="tv-tooltip"
          data-tooltip-content={
            !isDragable
              ? state.translate("oneButton.noConnectionAvailable", "Keine Verbindung vorhanden")
              : itx("oneButton.dragAndDropHere", "Verbindungen verschieben")
          }
          data-tooltip-place="bottom"
        ></i>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "30px",
            minWidth: "50px",
            backgroundColor: "var(--lightLightGrey)",
            border: "1px solid var(--borderColorDarkGrey)",
            borderRadius: "5px",
            padding: "5px",
            flexGrow: "1",
          }}
          data-tooltip-id="tv-tooltip"
          data-tooltip-content={
            connectionElements.length == 0
              ? state.translate(
                  "oneButton.draganddrop",
                  "Hier können Sie ein Verbraucher draufziehen um ihn mit dem Taster zu verbinden",
                )
              : ""
          }
          data-tooltip-place="bottom"
        >
          {connectionElements}
        </div>
      </div>
    );
  }
  return <div></div>;
}

export function ChannelTypeElement(props: { channel: Channel; device: Device }) {
  const { channel, device } = props;

  useOnChangeWatcher(channel);

  function ChannelTypeButtonSetToParemeterButton(props: {}) {
    return (
      <button
        className="button circle"
        onClick={() => {
          // handle the click event to change the channel type
          if (channel.mappedChannel) {
            channel.channelType = channel.mappedChannel.channelType;
            channel.raiseOnChange("channelType");
            channel.connections.forEach((con) => {
              const partner = con.getPartner(channel);
              if (partner) {
                con.forbidden = !AllowedConections.isConnectionAllowed(channel, partner, false);
                con.raiseOnChange("forbidden");
              }
            });
          }
        }}
        data-tooltip-class-name="tv-tooltip"
        data-tooltip-id="tv-tooltip"
        data-tooltip-content={state.translate(
          "oneButton.changeToParameterChannelType",
          "Ändere den Kanaltyp auf den in den Parametern ausgewählten Kanaltyp",
        )}
        data-tooltip-place="bottom"
      >
        <i className="las la-exclamation-triangle" />
      </button>
    );
  }

  let hasScript_mapChannelType = false;
  const template = channel.parentDevice?.template;

  if (template?.knxProductData.hasScript_mapChannelType) {
    hasScript_mapChannelType = true;
  }

  if (channel.canControlChannelType || !device.template?.knxProductData) {
    //    if (channel.isButtonChannel && (channel.canControlChannelType || !button.template?.knxProductData)) {
    if (!hasScript_mapChannelType && channel.getKnxChannelTypePropertyValue() == ChannelType.Unknown) {
      //
      // Der Benutzer hat in en Parametern einen Auswahl für den ChannelType getroffen,
      // der ein nicht von Estada unterstützer ChannelType ist.
      //
      // zB "Wertgeber"
      //
      let s =
        "Der in den Parametern ausgewählte Kanaltyp ist Estada unbekannt.\n Der Kanaltype wurde aufgrund der Signale des Kanals ermittelt.";
      s = s.replaceAll("\n", "<br/>");

      return (
        <div
          style={{ padding: "5px", backgroundColor: "yellow", cursor: "default" }}
          data-tooltip-id="tv-tooltip"
          data-tooltip-html={s}
          data-tooltip-place="bottom"
          data-tooltip-variant={"warning"} // no itx
        >
          {" "}
          {state.translate("channelType." + channel.channelType)}
        </div>
      );
    } else if (channel.channelType == ChannelType.TemperatureMeasurement) {
      return <div>{state.translate("channelType.TemperatureMeasurement")}</div>;
    } else {
      let isParameterChannelTypeCompatible = true;

      let channelTypeTooltipText: string | undefined;
      let channelTooltipVariant: VariantType | undefined;

      let isParameterChannelTypeDifferent = false;
      if (!template?.knxProductData.hasScript_mapChannelType) {
        //
        // mit script passt der ChannelType per definition
        // das das Script ihn ja immer passend setzt
        //
        isParameterChannelTypeDifferent = channel.knxChannel ? channel.isParameterChannelTypeDifferent() : false;
      }

      if (isParameterChannelTypeDifferent) {
        channelTooltipVariant = "warning"; // no itx
        channelTypeTooltipText = itx(
          "oneButton.otherChannelSelectedInParameter",
          "Der Kanaltyp der Taste und des Verbrauchers sind verschieden, aber kompatibel",
        );

        isParameterChannelTypeCompatible = (channel as ButtonChannel).isParameterChannelTypeCompatible();
        if (!isParameterChannelTypeCompatible) {
          channelTooltipVariant = "error";
          if (channel.connections.size > 0) {
            channelTypeTooltipText = itx(
              "oneButton.channelIsIncompatible",
              "Der Verbraucher kann nicht mit diesem Tastentyp verbunden werden",
            );
          } else {
            // MWE 7.4.2025:
            // wenn ein Button nicht verbunden ist,
            // ist das generell KEIN Fehler
          }
        }
      } else {
        //const consumerChannelType = buttonChannel.getConnectedConsumer()?.channelType;
        const consumerChannelTypes = new Array<ChannelType>();
        channel.connections.forEach((conection) => {
          const partner = conection.getPartner(channel);
          if (partner) consumerChannelTypes.push(partner.channelType);
        });

        //
        // if the connected consumer has a diffenrt channelType,
        // we show the type allso in yellow only
        //
        if (consumerChannelTypes.length > 0) {
          if (channelTypeInfo(channel.channelType).isRollo) {
            let allPartnersAreRollos = true;
            consumerChannelTypes.forEach((type) => {
              if (!channelTypeInfo(type).isRollo) {
                allPartnersAreRollos = false;
              }
            });
            if (!allPartnersAreRollos) {
              isParameterChannelTypeDifferent = true;

              channelTypeTooltipText = itx(
                "oneButton.consumerChannelTypeDifferent",
                "Der Verbraucher hat einen abweichenden Type",
              );
            }
          } else if (channelTypeInfo(channel.channelType).isLight) {
            if (!consumerChannelTypes.includes(channel.channelType)) {
              isParameterChannelTypeDifferent = true;

              channelTypeTooltipText = itx(
                "oneButton.consumerChannelTypeDifferent",
                "Der Verbraucher hat einen abweichenden Type",
              );
            }
          }
        }

        // const consumerIsRollo =
        //   consumerChannelType == ChannelType.Blind || consumerChannelType == ChannelType.Jalousie;
        // const buttonIsRollo =
        //   buttonChannel.channelType == ChannelType.Blind || buttonChannel.channelType == ChannelType.Jalousie;
        // if (!(consumerIsRollo && buttonIsRollo)) {
        //   if (consumerChannelType && buttonChannel.channelType != consumerChannelType) {
        //     isParameterChannelTypeDifferent = true;

        //     channelTypeTooltipText = itx(
        //       "oneButton.consumerChannelTypeDifferent",
        //       "Der Verbraucher hat einen abweichenden Type",
        //     );
        //   }
        // }
      }

      let allowedChannelTypes = channel.allowedChannelTypes;

      if (isParameterChannelTypeDifferent) {
        //
        // dazu fehlen im Moment die Daten,
        // wird speichern nur die Mapping von unseren (bekannten) ChannelTypes auf PropertyValues
        //
        // otherChanelTypeText = OptionText der Property
        //
      }

      let options: any = [];

      if (!allowedChannelTypes) {
        allowedChannelTypes = [
          { channelType: ChannelType.Disabled },
          { channelType: ChannelType.Switch },
          { channelType: ChannelType.StaircaseLight },
          { channelType: ChannelType.Dimmer },
          { channelType: ChannelType.TuneableWhite },
          { channelType: ChannelType.Rgb },
          { channelType: ChannelType.Jalousie },
          { channelType: ChannelType.Blind },
          { channelType: ChannelType.Heating },
          { channelType: ChannelType.TemperatureSetpoint },
          { channelType: ChannelType.Scene },
        ];
      }

      // if the allowedChannelTypes contains Scene and this channel is a rocker channel, we should remove Scene

      if (channel.rockerConfig == RockerConfig.rocker) {
        allowedChannelTypes = allowedChannelTypes.filter((i) => i.channelType != ChannelType.Scene);
      }

      // we only allow to map GenericValue to switch if no real switch is available.
      const containsSwitch = allowedChannelTypes.find((i) => i.channelType == ChannelType.Switch);
      if (containsSwitch) {
        allowedChannelTypes = allowedChannelTypes.filter((i) => i.channelType != ChannelType.GenericValue);
      }

      options = allowedChannelTypes.map((allowedChannelType) => {
        if (allowedChannelType.channelType == ChannelType.GenericValue) {
          allowedChannelType = { channelType: ChannelType.Switch, text: itx("channelType.Switch") };
        }

        let text = itx("channelType." + allowedChannelType, allowedChannelType.channelType);
        if (allowedChannelType.text && !isParameterChannelTypeDifferent) {
          text += ` (${allowedChannelType.text})`;
        }

        return (
          <option key={allowedChannelType.channelType} value={allowedChannelType.channelType}>
            {state.translate("channelType." + allowedChannelType.channelType, text)}
          </option>
        );
      });
      // // we check if knxchannelType is in options, if not we add it ?????
      // const knxChannelType = channel.knxChannel?.channelType;
      // if (
      //   knxChannelType &&
      //   !allowedChannelTypes.find((i) => i.channelType == knxChannelType) &&
      //   knxChannelType != ChannelType.Unknown
      // ) {
      //   options.push(
      //     <option value={knxChannelType}>{state.translate("channelType." + knxChannelType, knxChannelType)}</option>,
      //   );
      // }

      const displayedChannelTypes = new Set<ChannelType>(
        allowedChannelTypes.map((item) =>
          item.channelType == ChannelType.GenericValue ? ChannelType.Switch : item.channelType,
        ),
      );
      if (!displayedChannelTypes.has(channel.channelType)) {
        options.push(
          <option key={`current-${channel.channelType}`} value={channel.channelType} disabled>
            {state.translate("channelType." + channel.channelType, channel.channelType)}
          </option>,
        );
      }

      return (
        <div
          style={{ paddingLeft: "5px" }}
          onClick={(ev) => {
            ev.stopPropagation();
          }}
        >
          <select
            style={{
              backgroundColor: isParameterChannelTypeCompatible
                ? isParameterChannelTypeDifferent
                  ? "yellow"
                  : "transparent"
                : "var(--backgroundColorError)",
            }}
            className="select"
            data-tooltip-id="tv-tooltip"
            data-tooltip-content={channelTypeTooltipText}
            data-tooltip-place="bottom"
            data-tooltip-variant={channelTooltipVariant}
            key={channel.channelType}
            defaultValue={channel.channelType}
            // value={buttonChannel.channelType}
            onChange={async (ev) => {
              setChannelType(ev.currentTarget.value as ChannelType, device, channel);
            }}
          >
            {options}
          </select>
          {isUiModeDeveloper() && channel.hasKnxChannelTypeProperty && (
            <div style={{ color: "grey", fontSize: "10px" }}>id={channel.knxChannel?.knxChannelTypeProperty?.id}</div> // no itx
          )}
        </div>
      );
    }
  }

  // if channelType from parameter is not the same as channel.channelType,
  // we should show the warning symbol and button to change to the channeltype from the parameter
  let channelTypeErrorElement: any = null;
  let backgroundcolor = "transparent";
  if (channel.mappedChannel && channel.channelType != channel.mappedChannel?.channelType) {
    backgroundcolor = "var(--backgroundColorError)";
    channelTypeErrorElement = <ChannelTypeButtonSetToParemeterButton />;
  }

  return (
    <div
      style={{
        paddingLeft: "5px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "5px",
        backgroundColor: backgroundcolor,
      }}
      data-tooltip-id="tv-tooltip"
      data-tooltip-content={
        device.template?.knxProductData
          ? itx("OneButton.changeInParameter", "Tastentyp kann nur in den Parametern geändert werden")
          : ""
      }
      data-tooltip-place="bottom"
    >
      {state.translate(`channelType.${channel.channelType}`, channel.channelType)}
      {channelTypeErrorElement}
    </div>
  );
}
export default function OneButton(props: {
  device: Device;
  buttonChannel: Channel;
  previousButtonChannel: Channel | undefined;
  nextButtonChannel: Channel | undefined;
  index: number;
  redraw: () => void;
  withDelete: boolean;
}) {
  const { buttonChannel: channel, nextButtonChannel, previousButtonChannel, device, index, redraw, withDelete } = props;

  useOnChangeWatcher(channel);
  useOnChangeWatcher(channel.connections);

  const knxChannel = channel.mappedChannel;

  const displayAsActorChannel = channel.isActorChannel;

  let deleteButton: any = "";
  const errorSignElement: any = "";

  ///////////////////////////////////////////////////////////////
  ////////deleteButton

  if (channel.canBeDeletedInteractive()) {
    deleteButton = (
      <button
        className="button circle"
        style={{ position: "absolute", top: "-3px" }}
        onClick={(ev) => {
          const channelTypeBevor = channel.channelType;
        }}
      >
        <i className="las la-trash" />
      </button>
    );
  }

  ///////////////////////////////////////////////////
  ////////NameElements
  function NameElement(props: {}) {
    let nameElementStyle: any = {
      textAlign: "center",
      minWidth: "100px",
      border: channel.isLogicChannel ? undefined : "1px solid var(--defaultBackgroundColor)",
      //      paddingBottom: "0px",
      height: "35px",
      alignItems: "center",
      position: "relative",
      display: "flex",
    };

    const isRightButton = channel.buttonSide == ButtonSide.right || channel.buttonSide == ButtonSide.hidden;

    if (isRightButton) {
      // hidden == right button of virtual rocker
      nameElementStyle = {
        ...nameElementStyle,
        borderRadius: "0px 30px 30px 0px",
      };
    }

    if (channel.buttonSide == ButtonSide.left) {
      nameElementStyle = {
        ...nameElementStyle,
        borderRadius: "30px 0px 0px 30px",
      };
    }
    if (channel.buttonSide == ButtonSide.both) {
      nameElementStyle = {
        ...nameElementStyle,
        borderRadius: "30px",
        minWidth: "50px",
        display: "flex",
        flexDirection: "row",
        // justifyContent: "center",
      };
    }

    let elm1: any | undefined;

    const elm1Style: any = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",

      borderTopLeftRadius: "30px", // no itx
      borderBottomLeftRadius: "30px", // no itx
      backgroundColor: channel.isStatusChannel ? "var(--isStatusColor)" : "lightgray", // no itx
      minWidth: "100px",
      paddingLeft: "10px",
      paddingRight: "10px",
      height: "100%",
      cursor: "default",
    };

    if (isRightButton || channel.buttonSide == ButtonSide.hidden) {
      elm1Style.borderTopRightRadius = "30px"; // no itx
      elm1Style.borderBottomRightRadius = "30px"; // no itx
      elm1Style.borderTopLeftRadius = "";
      elm1Style.borderBottomLeftRadius = "";
    }

    if (displayAsActorChannel) {
      nameElementStyle.borderRadius = "0px";
      nameElementStyle.borderLeft = "3px solid grey";

      elm1Style.borderTopRightRadius = "";
      elm1Style.borderBottomRightRadius = "";
      elm1Style.borderTopLeftRadius = "";
      elm1Style.borderBottomLeftRadius = "";
    }

    if (channel.isLogicChannel) {
      nameElementStyle.borderLeft = "0px";
      nameElementStyle.backgroudColor = "red";

      nameElementStyle.borderTopRightRadius = "0px";
      nameElementStyle.borderBottomRightRadius = "0px";
      nameElementStyle.borderTopLeftRadius = "0px";
      nameElementStyle.borderBottomLeftRadius = "0px";

      if (channel.isLogicOutputChannel) {
        elm1Style.marginLeft = "100px";
      }
    }

    elm1 = (
      <div className="elm1" style={elm1Style}>
        {channel.getChannelNameForUI()}
      </div>
    );

    if (!device.template) {
      elm1 = undefined;
    } else if (!knxChannel) {
      if (channel.channelType == ChannelType.Scene) {
        elm1 = (
          <div style={elm1Style}>
            <img style={{ height: "100%", padding: "7px" }} src="/images/various/scene.png"></img>
          </div>
        );
      } else if (!knxChannel && channel.channelType == ChannelType.Disabled) {
        elm1 = <div style={elm1Style}>{channel.getChannelNameForUI()}</div>;
      } else {
        elm1 = (
          <div
            style={{ ...elm1Style, border: "2px solid red", backgroundColor: "var(--backgroundColorError)" }}
            data-tooltip-id="tv-tooltip"
            data-tooltip-content={state.translate(
              "oneButton.noChannelinParameter",
              "Kein Kanal in den Parametern konfiguriert!",
            )}
            data-tooltip-place="bottom"
            data-tooltip-variant="error"
          >
            {channel.getChannelNameForUI()}
          </div>
        );
      }
    }

    const elm2 = channel.isLogicChannel ? null : (
      <EditableText
        obj={channel}
        property="nameOrConnectedNames" // no itx
        propertyType="text"
        multiline={false}
        style={{
          flexGrow: "1",
          height: "100%",
          paddingLeft: "10px",
          paddingRight: "10px",
          marginLeft: "0px",
          marginRight: "0px",
        }}
        onBlur={() => {
          channel.manualName = channel.name != "";
          //
          // if a "name/text" Property is linked via Scripting,
          // update it here
          //
          device.template?.knxProductData.currentRules?.pullAllValues(device, {});
          device.updateAllFromKnxMetadata();
        }}
      />
    );

    const colSpan2 =
      channel.buttonSide == ButtonSide.both ||
      channel.isLogicChannel ||
      channel.isStatusChannel ||
      channel.isActorChannel;

    return (
      <td
        colSpan={colSpan2 ? 2 : 1}
        style={{
          paddingLeft: "5px",
          paddingRight: "5px",
          verticalAlign: "middle",
          minWidth: "200px",
        }}
        onClick={(ev) => {
          if (state.selectionManager.selectedObject != channel) {
            state.selectionManager.selectedObject = channel;
          }
        }}
      >
        <div style={nameElementStyle}>
          {channel.isLogicInputChannel && <div className="triangleIn"></div>}
          {!isRightButton && elm1}
          {elm2}
          {isRightButton && elm1}

          {!channel.isLogicChannel &&
            !channel.isActorChannel &&
            channel.buttonSide == ButtonSide.both &&
            device.template && (
              <div
                style={{
                  height: "100%",
                  borderRadius: "0px 30px 30px 0px",
                  backgroundColor: channel.isStatusChannel ? "var(--isStatusColor)" : "lightgray", // no itx
                  width: "40px",
                }}
              ></div>
            )}

          {channel.isLogicOutputChannel && <div className="triangleOut"></div>}
        </div>
      </td>
    );
  }

  //
  // HidenButtons are the right button of a "virtual rocker"
  //
  // For non Developers these buttons are hidden
  //

  const isHiddenButton = channel.buttonSide == ButtonSide.hidden;
  if (isHiddenButton && !isUiModeProductAdmin()) {
    return null;
  }

  let splitButton: any = null;

  if (
    channel.isButtonChannel &&
    device.baseProps.buttonBaseProps?.supportsSplitRocker &&
    !channel.isStatusChannel &&
    !channel.isLogicChannel
  ) {
    const isRocker = channel.buttonSide === ButtonSide.both;

    if (channel.supportsRockerConfig) {
      splitButton = (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "25px",
          }}
        >
          <div
            key={`leftCircle-${channel.buttonSide}`}
            style={{
              cursor: "pointer",
              paddingRight: "0px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              height: "max-content",
              width: "max-content",
              margin: "5px",
            }}
            data-tooltip-id="tv-tooltip"
            data-tooltip-content={
              channel.buttonSide == ButtonSide.both
                ? itx("OneButton.useBouthButtons", "Beide Tasten gemeinsam nutzen")
                : itx("OneButton.useButtonsSingle", "Tasten einzeln nutzen")
            }
            data-tooltip-place="top" // no itx
            onClick={async () => {
              await toggleButtonChannelSplit(channel as ButtonChannel);

              redraw();
            }}
          >
            {/* {buttonChannel.buttonSide} */}
            <div
              style={{
                width: "20px",
                height: "20px",
                borderTopLeftRadius: "10px",
                borderBottomLeftRadius: "10px",
                border: "2px solid var(--defaultBorderColor)",
                background: !isRocker ? "var(--selectedOrange)" : "var(--colorTransparent)",
              }}
            />
            <div
              style={{
                width: "20px",
                height: "20px",
                marginLeft: "1px",
                borderTopRightRadius: "10px",
                borderBottomRightRadius: "10px",
                border: "2px solid var(--defaultBorderColor)",
                background: !isRocker ? "var(--selectedOrange)" : "var(--colorTransparent)",
              }}
            />
          </div>
        </div>
      );
    }
  }

  let longPress = false;
  let extraLongPress = false;

  //
  //
  // Patchtaste hat keine Split option
  //
  if (channel.tag.startsWith("TP")) {
    splitButton = null;
  }

  longPress = channel.tag.endsWith("_l");
  extraLongPress = channel.tag.endsWith("_x");

  ///////////////////////////////////////////////////
  /////////////// connectionDropDownElement
  function ConnectionDropDown(props: {}) {
    const room = device.className == "Button" ? (device.parent as Room) : undefined;

    useOnChangeWatcher(channel, (changedProperty, changedObject) => {
      if (changedProperty == "channelType") {
        return true;
      }
      return false;
    });
    useOnChangeWatcher(room, (changedProperty, changedObject) => {
      /// to much rerender !!!!!!!!!!!!
      // if (changedProperty=="ChildCollection"){
      //   return true
      // }
      return false;
    });

    function customizableButtonChannel(channelType: ChannelType): boolean {
      let res = false;
      channel.allowedChannelTypes?.forEach((allowed) => {
        if (allowed.channelType == channelType) {
          res = true;
        }
      });
      return res;
    }

    const info = channelTypeInfo(channel.channelType);
    let show =
      info.canBeConnectedWithButtonChannel ||
      (info.isStatusChannel && device.isPanel) ||
      channel.channelType == ChannelType.TemperatureSetpoint;
    if (channel.isStatusChannel) {
      show = true;
    }
    if (channel.isActorChannel) {
      show = false;
    }
    if (show && room) {
      const connectableObjects = new Array<ConnectableObject>();

      let options = new Array<any>();

      state.allConsumers().forEach((consumer) => {
        if (AllowedConections.isConnectionAllowed(consumer, channel, true)) {
          connectableObjects.push(consumer);
        }
      });
      ////////////////////////////
      ///// set options for own Room
      const connectableObjectsOfThisRoom = room.consumers
        ?.sortBy("tag")
        ?.filter((cons) => AllowedConections.isConnectionAllowed(cons, channel, true));
      const optionForThisRoom = new Array<any>();
      connectableObjectsOfThisRoom.forEach((obj) => {
        optionForThisRoom.push({
          value: obj.id,
          label: `${obj.tag} ${obj.name}`,
        });
      });
      if (optionForThisRoom.length > 0) {
        options.push({
          options: optionForThisRoom,
          label: `${room.fullTag} ${room.name} (${itx("oneButton.ownRoom", "eigener Raum")})`,
        });
      }
      ////////////////////////////////////
      ///// options for other Rooms
      const allRooms = state.allRooms().filter((r) => r != room);
      allRooms.forEach((otherRoom) => {
        const connectableObjectsOfThisRoom = otherRoom.consumers
          ?.sortBy("tag")
          ?.filter((cons) => AllowedConections.isConnectionAllowed(cons, channel, true));
        const optionForThisRoom = new Array<any>();
        connectableObjectsOfThisRoom.forEach((obj) => {
          optionForThisRoom.push({
            value: obj.id,
            label: `${obj.tag} ${obj.name}`,
          });
        });
        if (optionForThisRoom.length > 0) {
          options.push({
            options: optionForThisRoom,
            label: `${otherRoom.fullTag} ${otherRoom.name}`,
          });
        }
      });
      ///////////////////////////////////////////////////
      /////Scenen
      const optionScenes = new Array<any>();
      const connectableScenes = new Array<Scene>();
      state
        .allScenes()
        .filter((a) => a.className == "Scene")
        .forEach((scene) => {
          if (
            !AllowedConections.isAlreadyConnected(scene, channel) &&
            (AllowedConections.isConnectionAllowed(scene, channel, true) ||
              (channel.connections.size == 0 && customizableButtonChannel(scene.channelType)))
          ) {
            connectableScenes.push(scene);
          }
        });
      connectableScenes.forEach((obj) => {
        optionScenes.push({
          value: obj.id,
          label: `${obj.tag} ${obj.name}`,
        });
      });
      if (optionScenes.length > 0) {
        options.push({
          options: optionScenes,
          label: `${itx("components.plural.Scene")}`,
        });
      }
      ///////////////////////////////////////////////////
      /////Multiplexer
      const optionMultiplexer = new Array<any>();
      const connectableMultiplexers = new Array<Scene>();
      state
        .allScenes()
        .filter((a) => a.className == "Multiplexer")
        .forEach((multiplexer) => {
          if (
            !AllowedConections.isAlreadyConnected(multiplexer, channel) &&
            (AllowedConections.isConnectionAllowed(multiplexer, channel, true) ||
              (channel.connections.size == 0 && customizableButtonChannel(multiplexer.channelType)))
          ) {
            connectableMultiplexers.push(multiplexer);
          }
        });
      connectableMultiplexers.forEach((obj) => {
        optionMultiplexer.push({
          value: obj.id,
          label: `${obj.tag} ${obj.name}`,
        });
      });
      if (optionMultiplexer.length > 0) {
        options.push({
          options: optionMultiplexer,
          label: `${itx("components.plural.Multiplexer")}`,
        });
      }

      // sortArrayByProperty(connectableScenes, "sceneNumber") // to show the consumer in the same room first
      //   .forEach((obj) => {
      //     options.push({
      //       value: obj.id,
      //       label: `${obj.getRelativeTag(room)} ${obj.name}`,
      //     });
      //   });

      if (options.length <= 0) {
        options = [
          {
            value: noItx("noConnectionPossible"),
            label: itx("oneButton.noConnectionPossible", "Keine Verbindung möglich"),
          },
        ];
      }

      return (
        <Select
          // key={`${xid}-${currentValue}`}
          // className={`knxSelect autoHeight ${item.a.Cell ? "cell" : ""}`}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, width: "auto", minWidth: "100%" }),

            control: (baseStyles, state) => {
              const res = {
                ...baseStyles,
                borderColor: "var(--colorLightGrey)",
                minHeight: "30px",
                minWidth: "250px",
              };
              return res;
            },
            indicatorSeparator: (baseStyles, state) => ({
              ...baseStyles,
              width: "0",
            }),

            indicatorsContainer: (baseStyles, state) => ({
              ...baseStyles,
              height: "30px",
              padding: "0px",
            }),
          }}
          isDisabled={false}
          options={options}
          // defaultValue={"selectObj"} // no itx
          onChange={(item: any) => {
            if (item) {
              const obj = state.objectRegistry.getObject(item.value);
              if (obj) {
                channel.treeViewModel.handleDrop2(DragMode.link, obj as ConnectableObject);
                // ev.target.value = "selectObj"; // no itx
                showToast({ text: itx("oneButton.T1WasConnected", "T1 wurde verbunden", { T1: obj.fullTag }) });
              }
            }
          }}
          openMenuOnClick={true}
          // defaultValue={"addValue"}
          value={{
            value: "",
            label: itx(
              `oneButton.${options[0].value == "noConnectionPossible" ? "noConnectionPossible" : "addLink"}`,
              options[0].value == "noConnectionPossible" ? "noConnectionPossible" : "addLink",
            ),
          }}
          // placeholder={itx("oneButton.addLink", "Verknüpfung hinzufügen")}
        />
      );
    }
    return null;
  }

  ///////////////////////////////////////////////////
  //// Drag&Drop of connections

  function handleOnDrop(ev: DragEvent<HTMLDivElement>) {
    const dropChannel = channel;
    if (dragChannel != dropChannel && dragChannel) {
      // check if the channels have the same channeltype

      if (!dragChannel.knxChannel && dropChannel.knxChannel) {
        dragChannel.moveConnection(dropChannel);
      } else {
        changeConnection(dragChannel, dropChannel);
      }
    } else {
      channel.treeViewModel.onDrop(ev);
    }
    dragChannel = undefined;
  }

  function getAllNewAndOldChannels(
    fromChannel: Channel,
    toChannel: Channel,
  ): Array<{
    oldConnection: Connection;
    newConnection: Connection;
  }> {
    const dropDragChannelConnections = new Array<{
      oldConnection: Connection;
      newConnection: Connection;
    }>();

    fromChannel.connections.forEach((connection) => {
      const newConnection = new Connection({}, connection.parent);
      (connection.parent as Page).connections.add(newConnection);
      newConnection.type = connection.type;

      if (fromChannel?.id == connection.fromId && fromChannel) {
        newConnection.fromDevice = toChannel;
        newConnection.toDevice = connection.toDevice;
      } else if (fromChannel.id == connection.toId && fromChannel) {
        newConnection.fromDevice = connection.fromDevice;
        newConnection.toDevice = toChannel;
      } else {
        logger.error("connection wrong in Channel", fromChannel, connection);
      }
      dropDragChannelConnections.push({
        oldConnection: connection,
        newConnection: newConnection,
      });
    });

    return dropDragChannelConnections;
  }

  function changeConnection(dragChannel: Channel, dropChannel: Channel) {
    let switchPossible = dropChannel.connections.size != 0 || dropChannel.connections.size == 0;
    // scene is not connectable with switchstatus
    if (
      (channelTypeInfo(dragChannel.channelType).isStatusChannel && dropChannel.channelType == ChannelType.Scene) ||
      (channelTypeInfo(dropChannel.channelType).isStatusChannel && dragChannel.channelType == ChannelType.Scene)
    ) {
      switchPossible = false;
    }
    if (switchPossible) {
      let dropDragChannelConnections = getAllNewAndOldChannels(dragChannel, dropChannel);

      // transfer connecion to droped channel
      if (
        !channelTypeInfo(dragChannel.channelType).isStatusChannel &&
        !channelTypeInfo(dropChannel.channelType).isStatusChannel
      ) {
        dropDragChannelConnections = dropDragChannelConnections.concat(
          getAllNewAndOldChannels(dropChannel, dragChannel),
        );
      }

      // switch names of buttonChennel
      const dragNameBefor = dragChannel.name;
      const dropNameBefor = dropChannel.name;

      const dragChannelTypeBefor = dragChannel.channelType;
      const dropChannelTypeBefore = dropChannel.channelType;
      if (channelTypeInfo(dragChannel.channelType).isStatusChannel) {
        dropChannel.name = dragNameBefor;
      }
      dragChannel.name = dropNameBefor;

      if (
        channelTypeInfo(dragChannel.channelType).isStatusChannel ||
        channelTypeInfo(dropChannel.channelType).isStatusChannel ||
        (dropChannel.allowedChannelTypes && dropChannel.allowedChannelTypes.length <= 1) ||
        (dragChannel.allowedChannelTypes && dragChannel.allowedChannelTypes.length <= 1)
      ) {
      } else {
        dropChannel.channelType = dragChannelTypeBefor;
        dragChannel.channelType = dropChannelTypeBefore;

        dragChannel.raiseOnChange("channelType");
        dropChannel.raiseOnChange("channelType");
      }

      dragChannel.raiseOnChange("name");
      dropChannel.raiseOnChange("name");
      const toDeleteConnections = new Array<Connection>();

      let firstSwitchStatusConnection = false;
      dropDragChannelConnections
        .sort((a, b) => {
          const nameA = a.oldConnection.toDevice?.tagOrName || "";
          const nameB = b.oldConnection.toDevice?.tagOrName || "";
          const compareValue = nameA.localeCompare(nameB);
          return compareValue ? compareValue : 0;
        })
        .forEach((connection) => {
          const newConnectionfromDeviceChannelType = connection.newConnection.fromDevice?.channelType;
          const newConnectiontoDeviceChannelType = connection.newConnection.toDevice?.channelType;
          if (
            (newConnectionfromDeviceChannelType &&
              channelTypeInfo(newConnectionfromDeviceChannelType).isStatusChannel) ||
            (newConnectiontoDeviceChannelType && channelTypeInfo(newConnectiontoDeviceChannelType).isStatusChannel)
          ) {
            if (!firstSwitchStatusConnection) {
              if (
                newConnectionfromDeviceChannelType &&
                channelTypeInfo(newConnectionfromDeviceChannelType).isStatusChannel &&
                channelTypeInfo(dropChannel.channelType).isStatusChannel
              ) {
                // delete old connection
                const deletedObjects = connection.newConnection.fromDevice?.connections.asArray()[0]?.delete() || [];
              } else if (
                newConnectiontoDeviceChannelType &&
                channelTypeInfo(newConnectiontoDeviceChannelType).isStatusChannel &&
                channelTypeInfo(dropChannel.channelType).isStatusChannel
              ) {
                const deletedObjects = connection.newConnection.toDevice?.connections.asArray()[0]?.delete() || [];
              }
              // add new connection

              connection.newConnection.addToConnectableObjects();
            }
            firstSwitchStatusConnection = true;
          } else if (channelTypeInfo(dragChannel.channelType).isStatusChannel) {
            // check if Connection to consumer allready availiable
            let consumer = connection.newConnection.fromDevice;
            if (!consumer?.isConsumer) {
              consumer = connection.newConnection.toDevice;
            }
            if (consumer) {
              let allreadyConnected = false;
              dragChannel.connections.forEach((con) => {
                if (con.fromDevice == consumer || con.toDevice == consumer) {
                  allreadyConnected = true;
                }
              });
              if (!allreadyConnected) {
                // add new connection
                connection.newConnection.addToConnectableObjects();
              }
            }
          } else {
            // add new connection
            connection.newConnection.addToConnectableObjects();

            // cant be done because of deletion of channel if no connection is left
            // delete old connection
            toDeleteConnections.push(connection.oldConnection);
          }
        });

      // has to be afterwards because otherwise we would delete the connection before creating the new one so the channel would be deleted because no connection is left
      toDeleteConnections.forEach((con) => {
        const deletedObjects = con.delete();
      });

      // recalculate connetion dependend knxProperties, channels, channelNames etc.
      (dropChannel.parent as Device)?.updateAllFromKnxMetadata();

      device.updateAllFromKnxMetadata().then((value) => {
        device.channels.forEach((buttonChannel) => {
          buttonChannel.connections.forEach((con) => {
            const source = con.fromDevice;
            const target = con.toDevice;
            if (source && target) {
              let allowed1 = true;
              if (buttonChannel.knxChannel) {
                allowed1 = areChannelTypesCompatible(
                  buttonChannel.channelType,
                  buttonChannel.knxChannel.channelType,
                  device,
                );
              }

              const forbidden = !AllowedConections.isConnectionAllowed(target, source, false);
              if (forbidden != con.forbidden) {
              }
              con.forbidden = forbidden || !allowed1; // no itx
            }
          });
        });
      });
    } else {
      showToast({
        text: state.translate("oneButton.changeNotPermitted", "tauschen nicht zulässig"),
      });
    }
  }

  let configButtonSplit = true;

  // console.log(`oneButton ${buttonChannel.tag}  ${buttonChannel.name} ${buttonChannel.buttonSide}`);

  //////////////////////////////////////////////////////////////////////////
  // buttonNumberText

  const numberOfButtonFromTag = parseInt(channel.tag.replace(/\D/g, ""));
  let buttonNumberText: any = itx("components.ButtonChannel", "Taste") + " " + `${numberOfButtonFromTag}`;

  if (channel.isActorChannel) {
    buttonNumberText = itx("components.Channel") + " " + `${numberOfButtonFromTag}`;
  }

  if (device.baseProps.buttonBaseProps?.supportsSplitRocker) {
    buttonNumberText = "Wippe " + `${numberOfButtonFromTag}`; // no itx
  }

  if (channel.isStatusChannel) {
    buttonNumberText = itx("components.StatusLed", "Status") + " " + `${numberOfButtonFromTag}`;
  }

  if (channel.tag.startsWith(TAG_TX) || channel.isLogicChannel) {
    buttonNumberText = "";
  }

  if (channel.tag.startsWith("TP")) {
    buttonNumberText = "Patsch"; // no itx
  }

  if (!device.baseProps.buttonBaseProps?.supportsSplitRocker) {
    if (channel.rockerConfig == RockerConfig.none) {
      buttonNumberText = null;
    }
  }

  //////////////////////////////////////////////////////////////////////////

  let drawBorder = false;

  //
  // jede Zweitasten Wippe bekommt eine Abgrenzung
  //
  if (
    channel.buttonSide == ButtonSide.both &&
    !displayAsActorChannel &&
    channel.channelType != ChannelType.TemperatureMeasurement &&
    buttonNumberText
  ) {
    drawBorder = true;
  }

  //
  // jede line Einzeltaste bekommt eine Abgrenzung, wenn sie nicht lonngPress oder extraLongPress ist
  //
  if (channel.buttonSide == ButtonSide.left && channel.tag.endsWith("L")) {
    drawBorder = true;
  }

  if (displayAsActorChannel) {
    configButtonSplit = false;
  }

  let borderTop = drawBorder ? "50px solid white" : undefined; // no itx
  if (displayAsActorChannel || channel.isLogicChannel) {
    borderTop = "20px solid white";
  }

  let functionNumber = "";
  if (!isUiModeDeveloper() && device.isPanel) {
    const n = parseInt(channel.tag.substring(1));
    if (!isNaN(n)) {
      functionNumber = `F${n}`;
    }
  }

  const isRightButton = channel.buttonSide == ButtonSide.right || channel.buttonSide == ButtonSide.hidden;

  //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <tr
      key={channel.id}
      style={{
        alignItems: "center",
        verticalAlign: "middle",
        borderTop: borderTop,
        backgroundColor: isHiddenButton ? "brown" : borderTop || isRightButton ? "#f4f4f4" : "transparent",
      }}
      onDragOver={(ev: DragEvent<HTMLDivElement>) => {
        ev.preventDefault();
      }}
      onDrop={(ev: DragEvent<HTMLDivElement>) => {
        handleOnDrop(ev);
      }}

      // has to be set in <td>s because of last element <Select> dont supports onClick()
      // onClick={(ev) => {
      //   if (state.selectionManager.selectedObject != buttonChannel) {
      //     state.selectionManager.selectedObject = buttonChannel;
      //   }
      // }}
    >
      <td
        style={{ verticalAlign: "top" }}
        onClick={(ev) => {
          if (state.selectionManager.selectedObject != channel) {
            state.selectionManager.selectedObject = channel;
          }
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            height: "100%",
            width: deleteButton ? "40px" : undefined,
          }}
        >
          {drawBorder && buttonNumberText && (
            <div
              style={{
                position: "absolute",
                left: "-5px",
                bottom: "0px",
                marginBottom: "29px",
                backgroundColor: "#f4f4f4",
                width: "max-content",
                padding: "5px",
                paddingLeft: "20px",
                paddingRight: "20px",
                height: "30px",
                borderTopLeftRadius: "30px",
                borderTopRightRadius: "30px",
              }}
            >
              {buttonNumberText}
            </div>
          )}
          {deleteButton}
          &nbsp;
        </div>
      </td>

      <td
        style={{
          paddingLeft: "0px",
          paddingRight: "5px",
        }}
        onClick={(ev) => {
          if (state.selectionManager.selectedObject != channel) {
            state.selectionManager.selectedObject = channel;
          }
        }}
      >
        {errorSignElement}
        {isUiModeProductAdmin() && `${channel.tag}/${knxChannel?.tag || "-"} `}
        {functionNumber}
      </td>

      {configButtonSplit && (
        <td
          style={{ verticalAlign: "middle" }}
          onClick={(ev) => {
            if (state.selectionManager.selectedObject != channel) {
              state.selectionManager.selectedObject = channel;
            }
          }}
        >
          {channel.channelType != ChannelType.TemperatureMeasurement &&
            channel.buttonSide != ButtonSide.right &&
            (previousButtonChannel == undefined || previousButtonChannel?.buttonSide != ButtonSide.left) &&
            splitButton}

          {longPress && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i className="las la-stopwatch" style={{ fontSize: "30px" }} />
            </div>
          )}
          {extraLongPress && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span style={{ color: "#888" }}>{itx("OneButton.2x", "2x")}</span>
              <i className="las la-stopwatch" style={{ marginLeft: "0px", fontSize: "30px" }} />
            </div>
          )}
        </td>
      )}
      {!configButtonSplit && <td></td>}

      <td
        style={{ float: "right" }}
        onClick={(ev) => {
          if (state.selectionManager.selectedObject != channel) {
            state.selectionManager.selectedObject = channel;
          }
        }}
      ></td>

      {channel.channelType != ChannelType.TemperatureMeasurement &&
        (channel.buttonSide == ButtonSide.right || channel.buttonSide == ButtonSide.hidden) && (
          <td style={{ minWidth: "100px" }} />
        )}

      <NameElement />

      {channel.channelType != ChannelType.TemperatureMeasurement &&
        channel.channelType != ChannelType.Heating &&
        channel.channelType != ChannelType.TemperatureSetpoint &&
        channel.buttonSide == ButtonSide.left && (
          <td
            style={{ minWidth: "100px" }}
            onClick={(ev) => {
              if (state.selectionManager.selectedObject != channel) {
                state.selectionManager.selectedObject = channel;
              }
            }}
          />
        )}

      {/* {buttonChannel.channelType == ChannelType.TemperatureMeasurement && (
        <td colSpan={2} style={{ verticalAlign: "middle" }}>
          {buttonChannel.name}
        </td>
      )} */}

      <td
        style={{ verticalAlign: "middle" }}
        onClick={(ev) => {
          if (state.selectionManager.selectedObject != channel) {
            state.selectionManager.selectedObject = channel;
          }
        }}
      >
        <ChannelTypeElement channel={channel} device={device} />
      </td>

      <td
        style={{ verticalAlign: "middle" }}
        onClick={(ev) => {
          if (state.selectionManager.selectedObject != channel) {
            state.selectionManager.selectedObject = channel;
          }
        }}
      >
        <ConnectionGroupElement device={device} channel={channel} />
      </td>
      <td style={{ verticalAlign: "middle" }}>
        <ConnectionDropDown />
      </td>
    </tr>
  );
}

export function ButtonChannelErrorRow(props: { buttonChannel: Channel }) {
  const { buttonChannel } = props;
  useOnChangeWatcher(buttonChannel);
  if (buttonChannel.errors?.rockerTypeError || buttonChannel.errors?.channelTypeError) {
    return (
      <tr
        style={{
          alignItems: "center",
          verticalAlign: "middle",
          backgroundColor: "#f4f4f4",
        }}
      >
        <td>
          {" "}
          <img
            src={"images/warning.png"}
            style={{
              width: "25px",
              height: "25px",
              marginLeft: "10px",
              position: "relative",
            }}
          />
        </td>
        <td colSpan={14} style={{ color: "red" }}>
          {buttonChannel.errors?.rockerTypeError}
          {buttonChannel.errors?.channelTypeError}
        </td>
      </tr>
    );
  } else {
    return null;
  }
}
